import { IconButton } from "@core/components/IconButton";
import type { SafeHtmlAttributes } from "@core/types/SafeHtmlAttributes";
import classnames from "classnames";

import { UiCrossIcon } from "@jti/brand-icons/ui-cross";

import styles from "./MenuHeader.module.scss";

export type MenuHeaderProps = {
  title: string;
  onClose?: () => void;
  closeButtonLabel?: string;
  className?: string;
} & SafeHtmlAttributes<HTMLDivElement>;

export const MenuHeader = ({ title, onClose, closeButtonLabel = "Close", className, ...rest }: MenuHeaderProps) => (
  <div className={classnames(styles.header, className)} {...rest}>
    <span className={styles.title}>{title}</span>
    {onClose && (
      <div className={styles.closeButton}>
        <IconButton icon={UiCrossIcon} compact aria-label={closeButtonLabel} onClick={onClose} />
      </div>
    )}
  </div>
);
